import { onMounted } from "vue";

export default function useAutofocus() {
  onMounted(() => {
    const el = document.querySelector("[autofocus]") as HTMLElement;
    el.focus();
  });
}